// 获取缺省页显示的接口
import request from './request';
import store from '@/store';

async function getAccountInfo(){
    let res = await request({
        url: "/h5/CommonParameter/getAccountInfo",
        method: "post",
    })
    let AccountInfo = res.data.data

    store.commit('Public/AccountInfo',{data: AccountInfo})
    // console.log(this,'===========')
    return AccountInfo;  
}
export default getAccountInfo;